<div class="row shadow title-list bg-white rounded">
    <div class="col-lg-9 pl-5 pt-2">
        <h1 class="lblTitle-02">
            {{ 'companies.lblCompaniesTitle' | translate }}
        </h1>
    </div>
    <!-- <div class="col-lg-2">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>
          {{ 'common.filters.txtSearch' | translate }}
        </mat-label>
        <button class="btn-serch-field" (click)="searchInfo()"><mat-icon>search</mat-icon></button>
        <input type="text" matInput maxlength="50" [formControl]="f.txtName" autocomplete="off" (keyup)="searchInfo()" />
      </mat-form-field>
    </div> -->

    <div class="col-lg-3 pt-2 pb-4 pb-lg-0 text-right pr-5">
        <div class="btn-group">
            <!-- <button type="button" class="btn btn-secondary m-b-10 mr-2" (click)="removeFilter()">
          <i class="fas fa-times mr-1"></i>
          {{ 'common.btnClear' | translate }}
        </button> -->
            <button type="button" class="btn btn-primary m-b-10 mb-4" (click)="onOpen(mdlCreate)">
                <i class="fas fa-plus"></i>
                {{ 'common.btnNew' | translate }}
            </button>
        </div>
    </div>
</div>

<div class="container-fluid">

    <!-- LISTADO -->
    <div class="row px-3 mb-5 mt-4">
        <div class="content-wrap">
            <table class="table table-custom table-hover table-sm table-grid-responsive">
                <caption></caption>
                <thead class="th-custom">
                    <tr>
                        <th class="th-grid-responsive">{{ 'companies.gridColumns.Key' | translate }}</th>
                        <th class="th-grid-responsive">{{ 'companies.gridColumns.Name' | translate }}</th>
                        <th class="th-grid-responsive">{{ 'companies.gridColumns.RFC' | translate }}</th>
                        <th class="th-grid-responsive">{{ 'companies.gridColumns.ContactName' | translate }}</th>
                        <th class="th-grid-responsive">{{ 'companies.gridColumns.ContactEmail' | translate }}</th>
                        <th class="th-grid-responsive">{{ 'companies.gridColumns.CreateDate' | translate }}</th>
                        <th class="th-grid-responsive">{{ 'branch.gridColumns.Status' | translate }}</th>
                        <th class="text-center w-160-px"></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let data of dataInformation">
                        <tr class="tr-custom">
                            <td class="td-grid-responsive">
                                <span class="th-name-col">{{ 'companies.gridColumns.Key' | translate }}</span>
                                <span class="td-value-row"> {{ data.id }} </span>
                            </td>
                            <td class="td-grid-responsive">
                                <span class="th-name-col">{{ 'companies.gridColumns.Name' | translate }}</span>
                                <span class="td-value-row"> {{ data.name }} </span>
                            </td>
                            <td class="td-grid-responsive">
                                <span class="th-name-col">{{ 'companies.gridColumns.RFC' | translate }}</span>
                                <span class="td-value-row"> {{ data.rfc }} </span>
                            </td>
                            <td class="td-grid-responsive">
                                <span class="th-name-col">{{ 'companies.gridColumns.ContactName' | translate }}</span>
                                <span class="td-value-row"> {{ data.contactName }} </span>
                            </td>
                            <td class="td-grid-responsive">
                                <span class="th-name-col">{{ 'companies.gridColumns.ContactEmail' | translate }}</span>
                                <span class="td-value-row"> {{ data.contactEmail }}</span>
                            </td>
                            <td class="td-grid-responsive">
                                <span class="th-name-col">{{ 'companies.gridColumns.Status' | translate }}</span>
                                <span class="td-value-row"> {{ data.creationDate }} </span>

                            </td>
                            <td class="td-grid-responsive">{{data.enabled === true ? ('common.Active2' | translate) :
                                ('common.Inactive2' | translate) }}</td>
                            <td class="text-center td-content-btn td-grid-responsive flex w-160-px">
                                <!-- <button type="button" class="btn-none" [disabled]="true">
                                    <mat-slide-toggle [ngClass]="'status-obj'" [checked]="data.enabled" [disabled]="true" matTooltip="{{ data.enabledDescription }}"></mat-slide-toggle>
                                </button> -->

                                <button matTooltip="{{ 'companies.gridColumns.ViewDetails' | translate }}" type="button"
                                    class="btn-none" (click)="onViewItem(data.id, mdlView)">
                                    <mat-icon class="icon-table flex">visibility</mat-icon>
                                </button>

                                <button matTooltip="{{ 'companies.gridColumns.EditRecord' | translate }}" type="button"
                                    class="btn-none" (click)="onEditItem(data.id, mdlEdit)">
                                    <mat-icon class="icon-table flex">edit</mat-icon>
                                </button>
                                <ng-container *ngIf="data.sync">
                                    <button matTooltip="{{ 'companies.gridColumns.Sync' | translate }}" type="button"
                                        class="btn-none" (click)="onSync(data.id)">
                                        <mat-icon class="icon-table flex">sync</mat-icon>
                                    </button>
                                </ng-container>


                                <button *ngIf="data.enabled"
                                    matTooltip="{{ 'companies.gridColumns.DeleteRecord' | translate }}" type="button"
                                    class="btn-none" (click)="onDelete(data.id, data.name)">
                                    <mat-icon class="icon-table flex">delete</mat-icon>
                                </button>

                                <button *ngIf="!data.enabled" matTooltip="" type="button" class="btn-none btn-readonly">
                                    <mat-icon class="icon-table flex">delete</mat-icon>
                                </button>

                            </td>
                        </tr>
                    </ng-container>
                    <tr *ngIf="this.emptyDataList && this.IsPostBack" class="grid-empty text-center bg-light">
                        <td colspan="9" class="mt-3">
                            <span class="fa-stack">
                                <i class="fa-solid fa-filter fa-stack-1x"></i>
                                <i class="fa-solid fa-ban fa-stack-2x text-danger"></i>
                            </span>
                            <span class="text-info">{{ msgDataEmpty }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="row mt-1 mr-5">
                <div class="col-md-12 mb-5 d-flex justify-content-end">
                    <app-pagination-table [totalPages]="totalPages" [currentPage]="currentPage"
                        (changePage)="changePage($event)"></app-pagination-table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #mdlCreate>
    <div class="modal-header modal-header-custom">
        <div class="flex justify-content-space-between pt-2">
            <span class="fw-bold title-modal-detail fz-14-px">
                {{ 'companies.lblAddCompany' | translate }}
            </span>
            <p class="fz-11-px">* {{ 'common.lblsAreRequired' | translate }}</p>
        </div>
        <hr class="line-h-blue-purple-dialogs">
    </div>
    <div class="row">
        <div class="col-md-12">
            <app-create-company></app-create-company>
        </div>
    </div>
</ng-template>


<ng-template #mdlEdit>
    <div class="modal-header modal-header-custom">
        <div class="flex justify-content-space-between pt-2">
            <span class="fw-bold title-modal-detail fz-14-px">
                {{ 'companies.lblEditCompany' | translate }}
            </span>
            <p class="fz-11-px">* {{ 'common.lblsAreRequired' | translate }}</p>
        </div>
        <hr class="line-h-blue-purple-dialogs">
    </div>
    <div class="row ">
        <div class="col-md-12">
            <app-edit-company [childId]="idEntity"></app-edit-company>
        </div>
    </div>
</ng-template>

<ng-template #mdlView>
    <div class="modal-header modal-header-custom">
        <div class="flex justify-content-space-between pt-2">
            <span class="fw-bold title-modal-detail fz-14-px">
                {{ 'companies.lblDetailsCompany' | translate }}
            </span>
        </div>
        <hr class="line-h-blue-purple-dialogs">
    </div>
    <div class="row">
        <div class="col-md-12 mt-2">
            <app-detail-company [childId]="idEntity"></app-detail-company>
        </div>
    </div>
</ng-template>